import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9ha1ebi2: FaireBrandEntity = {
  token: "b_9ha1ebi2",
  type: "brand",
  name: "Animal Instincts",
  avatarUrl:
    "https://cdn.faire.com/fastly/dade5dbcfa4d1967343f5b6f7be387b7cc327be44c0c4037992e35e13f24685c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7beb89334a2159bdf22be8eef2d5d685b8357961e0b4f24c0a705e1881c9e3bd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/dade5dbcfa4d1967343f5b6f7be387b7cc327be44c0c4037992e35e13f24685c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7beb89334a2159bdf22be8eef2d5d685b8357961e0b4f24c0a705e1881c9e3bd.jpeg",
  location: "Northampton, MA, USA",
  minimumOrderDollars: 139,
  rating: 4.6,
  reviewCount: 15,
  isInsider: true,
  description:
    "Life's a zoo, dress accordingly.\n\nOriginal art and apparel that celebrates wildlife and brings joy to the whole family. Designed in Massachusetts by Jamai Lowell.\n\nWe make awesome, comfy clothes for the whole family. We know life with kids is never boring — why should children’s clothing be? Our animal print designs make getting dressed fun, simple, and fast. Even for toddlers. More time to explore this wild world together! Our sizes fit all the creatures in your animal kingdom and are one-of-a-kind to express everyone’s individuality.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:10.374Z",
    importedBy: "entity-db-cli",
  },
};
